import {Controller} from "stimulus"

export default class extends Controller {

  initialize() {
  }

  delay = milliseconds => new Promise(resolve => {
    setTimeout(resolve, milliseconds);
  });

  download = async (url, name) => {
    const a = document.createElement('a');
    a.download = name;
    a.href = url;
    a.style.display = 'none';
    document.body.append(a);
    a.click();

    // Chrome requires the timeout
    await this.delay(100);
    a.remove();
  };

  async multiDownload(urls, {rename} = {}) {
    if (!urls) {
      throw new Error('`urls` required');
    }

    for (const [index, url] of urls.entries()) {
      const name = typeof rename === 'function' ? rename({url, index, urls}) : '';

      await this.delay(index * 1000);
      this.download(url, name);
    }
  }

  connect() {

  }

  getAllLinkHrefs() {
    const links = this.element.querySelectorAll("a[download]");
    return Array.from(links).map(link => link.href);
  }

  startDownload(event) {
    event.preventDefault();
    this.multiDownload(this.getAllLinkHrefs());
  }
}
